export default __webpack_public_path__ + "static/media/avatarB8.ae28729d.png";